import { AssistantRuntimeProvider, useRemoteThreadListRuntime } from '@assistant-ui/react';
import { useScopeIds } from '@nohara-dxdev/react-oidc';
import { type PropsWithChildren, useMemo } from 'react';

import { useAiExternalStoreRuntime } from '../adapters/external-store.adapter';
import { createThreadListAdapter } from '../adapters/thread-list.adapter';

export const AiRuntimeProvider = ({ children }: PropsWithChildren) => {
  const { orgId, projectId } = useScopeIds('org', 'project');
  const adapter = useMemo(() => createThreadListAdapter({ orgId, projectId }), [orgId, projectId]);
  const runtime = useRemoteThreadListRuntime({
    runtimeHook: useAiExternalStoreRuntime,
    adapter,
  });
  return <AssistantRuntimeProvider runtime={runtime}>{children}</AssistantRuntimeProvider>;
};
